module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-09-fccd80c25c1808cdb0ed1b2d3f1bdd64.svg";